import React from 'react'

const TransactionCancelled = () => {
  return (
    <div>TransactionCancelled</div>
  )
}

export default TransactionCancelled